import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { GLOBAL } from './global';

@Injectable()
export class PagoService {
  public url: string;

  constructor(private http: HttpClient) {
    this.url = GLOBAL.url;
  }

  create(token, task): Observable<any> {
    return this.postRequest('/pago/new?page=1', token, task);
  }

  getPagos(token, page = 1): Observable<any> {
    return this.postRequest(`/pago/list?page=${page}`, token);
  }

  getPagosUser(token, page = 1, id): Observable<any> {
    return this.postRequest(`/pago/list/${id}?page=${page}`, token);
  }

  getPago(token, id): Observable<any> {
    return this.postRequest(`/pago/detail/${id}?page=1`, token);
  }

  update(token, task, id): Observable<any> {
    return this.postRequest(`/pago/edit/${id}?page=1`, token, task);
  }

  deletePago(token, id): Observable<any> {
    return this.postRequest(`/pago/remove/${id}?page=1`, token);
  }

  private postRequest(endpoint: string, token: string, body?: any): Observable<any> {
    let params = body ? `json=${JSON.stringify(body)}&authorization=${token}` : `authorization=${token}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });

    return this.http.post(`${this.url}${endpoint}`, params, { headers: headers })
      .pipe(map(res => res));
  }

  /////////////////////////////
  /* New Controller Payment */
  ///////////////////////////////
  private postRequestV1(endpoint: string, token: string, body?: any): Observable<any> {
    const payload = encodeURIComponent(JSON.stringify(body));
    let params = body ? `json=${payload}&authorization=${token}` : `authorization=${token}`;
    let headers = new HttpHeaders({ 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' });
    
    return this.http.post(`${this.url}${endpoint}`, params, { headers: headers })
      .pipe(map(res => res));
  }
  getlistcompanies(token): Observable<any> {
    return this.postRequest(`/payment/listcompany`, token);
  }

  getlistpobycompanies(token,data,page = 1,perpage = 10,filtros = []): Observable<any> {
    let url =`/payment/listpoby?page=${page}&perpage=${perpage}`;
    for (let filtro of filtros) {      
      if (filtro && filtro.value) {
        console.log(filtro.key);
        url = url + "&" + filtro.key + "=" + encodeURIComponent(filtro.value);
  
        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }
    return this.postRequestV1(url, token,data);
  }
////////////////////////////////////////////////////////////////////////////
  /* PAYMENT ACTIONS */
////////////////////////////////////////////////////////////////////////////


  getlistpayment(token,data,page = 1,perpage:any = 10,filtros = []): Observable<any> {
    let url =`/payment/listpayment?page=${page}&perpage=${perpage}`;
    for (let filtro of filtros) {      
      if (filtro && filtro.value) {
        console.log(filtro.key);
        url = url + "&" + filtro.key + "=" + encodeURIComponent(filtro.value);
  
        if (filtro.type) {
          url = url + "&" + filtro.key_type + "=" + filtro.type;
        }
      }
    }
    return this.postRequestV1(url, token,data);
  }


  Createnewpayment(token,data): Observable<any> {
    let url =`/payment/newrequestpayment`;

    return this.postRequestV1(url, token,data);
  }

  getpaymentbyid(token,data): Observable<any> {
    let url =`/payment/getpayment`;

    return this.postRequestV1(url, token,data);
  }

  changestatus(token,data): Observable<any> {
    let url =`/payment/changestatus`;

    return this.postRequestV1(url, token,data);
  }

  deletepayment(token,data): Observable<any> {
    let url =`/payment/deletepayment`;

    return this.postRequestV1(url, token,data);
  }

  updatepayment(token,data): Observable<any> {
    let url =`/payment/updatepayment`;

    return this.postRequestV1(url, token,data);
  }
  
  Createcosigment(token,data): Observable<any> {
    let url =`/payment/completeconsignmentpayment`;

    return this.postRequestV1(url, token,data);
  }

  completedata(token,data): Observable<any> {
    let url =`/payment/completepayment`;

    return this.postRequestV1(url, token,data);
  }

  createpayentpartial(token,data): Observable<any> {
    let url =`/payment/createPartialPayment`;

    return this.postRequestV1(url, token,data);
  }

  savepartial(token,data): Observable<any> {
    let url =`/payment/savePartialPayment`;

    return this.postRequestV1(url, token,data);
  }

  Getcompanyconfig(token): Observable<any> {
    let url =`/companyconfig/getcompanyconfig`;

    return this.postRequestV1(url, token);
  }

  SetCompanyConfig(token,data): Observable<any> {
    let url =`/companyconfig/newcompanyconfig`;

    return this.postRequestV1(url, token,data);
  }
////////////////////////////////////////////////////////////////////////////
  /* END PAYMENT ACTIONS */
////////////////////////////////////////////////////////////////////////////





}
